import { Dialog, CircularProgress } from "@mui/material";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import useApproveRejectApplication from "../../hooks/customers/useApproveRejectApplication";

const ApproveRejectModal = ({
  isOpen,
  handleClose,
  isApprove,
  application,
  refreshUrl,
}) => {
  const [reason, setReason] = useState("");

  const { handleApprove, handleReject, isLoading } =
    useApproveRejectApplication({
      onSuccess: () => {
        handleClose();
        setReason("");
      },
      refreshUrl: refreshUrl,
    });

  const handleSubmit = () => {
    if (isApprove) {
      handleApprove(application.business_id, reason);
    } else {
      handleReject(application.business_id, reason);
    }
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={isOpen}
      onClose={() => {
        if (!isLoading) {
          handleClose();
        }
      }}
    >
      <div className="bg-white p-5">
        <div className="flex justify-end">
          <button onClick={handleClose} disabled={isLoading}>
            <IoMdClose className="text-black w-6 h-6" />
          </button>
        </div>
        <h4 className="text-xl font-bold">
          {isApprove ? "Approve application" : "Reject application"}
        </h4>
        <p className="mt-3">
          {isApprove
            ? `Are you sure you want to approve this application for "${application?.business_name}"?`
            : `Are you sure you want to reject this application for "${application?.business_name}"?`}
        </p>

        <p className="mt-4 font-medium">Reason:</p>
        <input
          type="text"
          name=""
          id=""
          placeholder="Enter reason"
          className="mt-1 w-full border px-3 py-1.5 border-neutral-300 rounded-md"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={isLoading}
        />

        <div className="mt-6 flex justify-center items-center gap-5">
          <button
            onClick={handleSubmit}
            className="rounded-md bg-cyan-700 text-white px-4 py-2 flex items-center justify-center min-w-[100px] relative"
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              isApprove ? "Approve" : "Reject"
            )}
          </button>
          <button
            className="rounded-md border border-red-500 text-red-500 px-4 py-2"
            disabled={isLoading}
            onClick={handleClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ApproveRejectModal;
